import { Component, ElementRef, ViewChild, effect, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { SessionTimeoutService } from '@services/session-timeout.service';

@Component({
  selector: 'app-session-timeout-modal',
  imports: [TranslocoModule],
  templateUrl: './session-timeout-modal.component.html',
  styleUrl: './session-timeout-modal.component.css',
})
export class SessionTimeoutModalComponent {
  readonly sessionTimeoutService = inject(SessionTimeoutService);

  @ViewChild('dialog') private dialog!: ElementRef<HTMLDialogElement>;

  constructor() {
    effect(() => {
      const show = this.sessionTimeoutService.showWarningModal();
      const dialog = this.dialog?.nativeElement;
      if (!dialog) return;

      if (show && !dialog.open) {
        dialog.showModal();
      } else if (!show && dialog.open) {
        dialog.close();
      }
    });
  }

  stayLoggedIn(): void {
    this.sessionTimeoutService.stayLoggedIn();
  }

  logoutNow(): void {
    this.sessionTimeoutService.logoutNow();
  }
}
